export default __webpack_public_path__ + "static/media/web_welcome_background.39e3a408.png";